(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ll-advertorial-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Hero carousel: autoplay + manual arrows. Uses data-ll-hero-carousel*
    // attributes (distinct from the bundle section's data-ll-bundle-carousel*)
    // so the two carousels' scripts never collide, even though Shopify
    // combines every section's JS into one shared bundle on the page.
    document.querySelectorAll('[data-ll-hero-carousel]').forEach(function (root) {
      if (root.dataset.llHeroCarouselInit) return;
      root.dataset.llHeroCarouselInit = 'true';
      var track = root.querySelector('[data-ll-hero-carousel-track]');
      if (!track) return;
      var slides = track.children;
      if (slides.length <= 1) return;

      var index = 0;
      var timer = null;

      function go(i) { index = (i + slides.length) % slides.length; track.style.transform = 'translateX(-' + (index * 100) + '%)'; }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }
      function start() { stop(); timer = setInterval(next, 4000); }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      var nextBtn = root.querySelector('[data-ll-hero-carousel-next]');
      var prevBtn = root.querySelector('[data-ll-hero-carousel-prev]');
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      start();
    });

    // Sticky mobile CTA: only visible once the visitor has scrolled past the
    // hero, and hidden again the moment #ll-bundle is on screen, whether they
    // got there by tapping the sticky CTA itself (which scrolls to
    // #ll-bundle) or by scrolling there manually.
    var stickyBar = document.querySelector('[data-ll-hero-sticky]');
    var heroWatch = document.querySelector('[data-ll-hero-watch]');
    if (stickyBar && heroWatch && 'IntersectionObserver' in window) {
      var heroPassed = false;
      var bundleVisible = false;

      function updateStickyVisibility() {
        stickyBar.classList.toggle('ll-hero__sticky--visible', heroPassed && !bundleVisible);
      }

      var heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          heroPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          updateStickyVisibility();
        });
      }, { threshold: 0 });
      heroObserver.observe(heroWatch);

      var bundleSection = document.querySelector('#ll-bundle');
      if (bundleSection) {
        var bundleObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            bundleVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        }, { threshold: 0 });
        bundleObserver.observe(bundleSection);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-bundle-slot"]) return;
  try {
    
  (function () {
    // Manual carousel only, no autoplay: arrows advance the track, nothing
    // moves on its own. Uses its own data-ll-bundle-carousel attribute
    // (distinct from the hero's data-ll-hero-carousel) so this script never
    // touches the hero's carousel, and vice versa, even though Shopify
    // combines every section's JS into one shared bundle on the page.
    document.querySelectorAll('[data-ll-bundle-carousel]').forEach(function (root) {
      if (root.dataset.llBundleCarouselInit) return;
      root.dataset.llBundleCarouselInit = 'true';
      var track = root.querySelector('[data-ll-bundle-carousel-track]');
      if (!track) return;
      var slides = track.children;
      if (slides.length <= 1) return;

      var index = 0;
      function go(i) { index = (i + slides.length) % slides.length; track.style.transform = 'translateX(-' + (index * 100) + '%)'; }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }

      var nextBtn = root.querySelector('[data-ll-bundle-carousel-next]');
      var prevBtn = root.querySelector('[data-ll-bundle-carousel-prev]');
      if (nextBtn) nextBtn.addEventListener('click', next);
      if (prevBtn) prevBtn.addEventListener('click', prev);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
